import { getJson } from './client'
import type { Job, JobView } from '../types/voice'

// The jobs surface: a snapshot of mine, one with its log. The live side is the hub at hubUrl; the
// connection itself lives in hooks/useJobLive so no page ever holds a socket.
const jobs = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/jobs`

export const jobsApi = {
  list: (spoke: string, take = 20) => getJson<Job[]>(jobs(spoke), { take }),
  get: (spoke: string, jobId: string) => getJson<JobView>(`${jobs(spoke)}/${encodeURIComponent(jobId)}`),
}

export const hubUrl = `${(import.meta.env.VITE_SCOUT_API ?? '').replace(/\/$/, '')}/hubs/jobs`
